import { useParams } from "react-router";

export const useCurrentJobId = () => {
  const { jobId } = useParams();
  if (!jobId) {
    throw new Error("Current job id not found");
  }

  return jobId;
};
